import React, { Component } from "react";
import ThumbnailListItem from "./ThumbnailListItem";
import styles from "../../assets/css/modules/shared/thumbnail-list.css";

export class ThumbnailList extends Component {
  render() {
    let ThumbnailListItems = [];
    for (var i = 0; i < this.props.Items.length; i++) {
      ThumbnailListItems.push(
        <ThumbnailListItem
          key={i}
          IconSrc={this.props.Items[i].IconSrc}
          Heading={this.props.Items[i].Heading}
          Description={this.props.Items[i].Description}
          LinkText={this.props.Items[i].LinkText}
          LinkTo={this.props.Items[i].LinkTo}
          ExternalLinkTo={this.props.Items[i].ExternalLinkTo}
        />
      );
    }

    return (
      <div className={styles.thumbnailList}>
        <h2>{this.props.Heading}</h2>
        {this.props.Description && <p>{this.props.Description}</p>}
        <div className={styles.thumbnailListWrapper}>{ThumbnailListItems}</div>
      </div>
    );
  }
}

export default ThumbnailList;
